import isPaymentScheduleEnabled from 'checkout/selectors/payment/paymentSchedule/isPaymentScheduleEnabled'
import Clickable from 'components/Common/Clickable'
import FormatCurrency from 'components/Common/FormatCurrency'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import FormatPercent from 'components/utils/Formatters/FormatPercent'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import type { MouseEventHandler, ReactNode } from 'react'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  deposit: App.Tours.TourPaymentSchedule
  onInfoClick?: () => void
}

function formatDepositAmount(deposit: App.Tours.TourPaymentSchedule): ReactNode {
  return deposit.amountType === 'percentage'
    ? <FormatPercent value={deposit.amountValue} />
    : <FormatCurrency value={deposit.amountValue} />
}

function TourDepositTag({ deposit, onInfoClick }: Props) {
  const intl = useIntl()

  const handleInfoClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    onInfoClick!()
  }, [onInfoClick])

  const label = intl.formatMessage(
    {
      id: '0Nj0mw2C7cPrb3nTjpbw',
      defaultMessage: 'Secure with {amount} deposit',
      description: 'Deposit tag showing the amount or percentage required to secure a booking',
    },
    { amount: formatDepositAmount(deposit) },
  )

  return <CaptionTextBlock
    variant="large"
    weight="bold"
    colour="highlight-primary-dark"
    endIcon={!!onInfoClick && <Clickable onClick={handleInfoClick}><LineInfoCircleIcon colour="normal-contrast" /></Clickable>}
  >
    {label}
  </CaptionTextBlock>
}

export default withMountGuard(() => {
  return useAppSelector(isPaymentScheduleEnabled)
})(TourDepositTag)
